import {
  SystemPromptApiService,
  OpenAPI as PromptLibrary,
} from '../services/prompt-library';
import type {
  SystemPromptCreateRequestDto,
  SystemPromptUpdateRequestDto,
  SystemPromptResponseDto,
} from '../services/prompt-library';
import { getCurrentOrg } from './getCurrentOrg';

export type SystemPrompt = SystemPromptResponseDto;
export type SystemPromptCreate = SystemPromptCreateRequestDto;
export type SystemPromptUpdate = SystemPromptUpdateRequestDto;

export const createSystemPrompt = async (
  requestBody: SystemPromptCreate
): Promise<SystemPrompt> => {
  return await SystemPromptApiService.createSystemPrompt(requestBody);
};

export const updateSystemPrompt = async (
  id: string,
  requestBody: SystemPromptUpdate
): Promise<SystemPrompt> => {
  return await SystemPromptApiService.updateSystemPrompt(id, requestBody);
};

export const getSystemPromptById = async (
  id: string
): Promise<SystemPrompt> => {
  return await SystemPromptApiService.getSystemPrompt(id);
};

export const getAllSystemPrompts = async (): Promise<SystemPrompt[]> => {
  return await SystemPromptApiService.getSystemPrompts();
};

export const deleteSystemPrompt = async (id: string): Promise<void> => {
  return await SystemPromptApiService.deleteSystemPrompt(id);
};

export const previewSystemPrompt = async (payload: string): Promise<string> => {
  const token = PromptLibrary.TOKEN;

  const response = await fetch(
    `${process.env.REACT_APP_BILLING_BASE_API_URL}/management/system-prompts/preview`,
    {
      method: 'POST',
      body: payload,
      headers: {
        Accept: 'text/plain',
        ...(token && { Authorization: `Bearer ${token}` }),
        'x-ai-agent-organization-context': getCurrentOrg(),
      },
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Failed to preview system prompt: ${response.status} - ${errorText}`
    );
  }

  return response.text();
};
